import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/entity/user';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-password-change',
  templateUrl: './user-password-change.component.html',
  styleUrls: ['./user-password-change.component.scss'],
})
export class UserPasswordChangeComponent implements OnInit {
  entity: User;
  newPasswort: string;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<UserPasswordChangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User,
    private userService: UserService,
    private snackService: SnackbarService
  ) {
    this.entity = data;
  }

  ngOnInit(): void {}

  save(): void {
    this.userService.updateUser(this.entity).subscribe((res) => {
      this.snackService.open('user.password.passwordEdited', 4, 'success');
    });
    this.dialogRef.close();
  }

  abort(): void {
    this.dialogRef.close();
  }
}
